module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transdetail"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("交易管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("交易明细")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel down1"
  }, [_c('div', {
    staticClass: "panel-header panel-header__auto"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules
    }
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("交易时间")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "dateRangeValue"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "editable": false,
      "placeholder": "选择日期范围",
      "size": "small",
      "clearable": false
    },
    model: {
      value: (_vm.form.dateRangeValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "dateRangeValue", $$v)
      },
      expression: "form.dateRangeValue"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "choosetime"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeTime
    },
    model: {
      value: (_vm.form.choosetime),
      callback: function($$v) {
        _vm.$set(_vm.form, "choosetime", $$v)
      },
      expression: "form.choosetime"
    }
  }, _vm._l((_vm.choosetimes), function(item) {
    return _c('el-radio-button', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper orderno_nowrap"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("流水号")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "orderno"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-310",
    attrs: {
      "type": "number",
      "placeholder": "请输入流水号",
      "size": "small"
    },
    model: {
      value: (_vm.form.orderno),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderno", $$v)
      },
      expression: "form.orderno"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper orderno_nowrap"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("商户订单号")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "out_trade_no"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-310",
    attrs: {
      "type": "number",
      "placeholder": "请输入商户订单号",
      "size": "small"
    },
    model: {
      value: (_vm.form.out_trade_no),
      callback: function($$v) {
        _vm.$set(_vm.form, "out_trade_no", $$v)
      },
      expression: "form.out_trade_no"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper orderno_nowrap"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("通道流水号")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "chnlsn"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-310",
    attrs: {
      "type": "number",
      "placeholder": "请输入通道流水号",
      "size": "small"
    },
    model: {
      value: (_vm.form.chnlsn),
      callback: function($$v) {
        _vm.$set(_vm.form, "chnlsn", $$v)
      },
      expression: "form.chnlsn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [(!_vm.role.single) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("门店分组")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "fenzuid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    on: {
      "change": function($event) {
        return _vm.getShopList(_vm.form.fenzuid)
      }
    },
    model: {
      value: (_vm.form.fenzuid),
      callback: function($$v) {
        _vm.$set(_vm.form, "fenzuid", $$v)
      },
      expression: "form.fenzuid"
    }
  }, _vm._l((_vm.grouplist), function(group) {
    return _c('el-option', {
      key: group.group_id,
      attrs: {
        "label": group.group_name,
        "value": group.group_id
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.role.single) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc panel-select__desc2"
  }, [_vm._v("门店")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "selectShopUid"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    on: {
      "change": function($event) {
        return _vm.getOperators(_vm.form.selectShopUid)
      }
    },
    model: {
      value: (_vm.form.selectShopUid),
      callback: function($$v) {
        _vm.$set(_vm.form, "selectShopUid", $$v)
      },
      expression: "form.selectShopUid"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.shopData.list), function(shop) {
    return _c('el-option', {
      key: shop.uid,
      attrs: {
        "label": shop.shop_name,
        "value": shop.uid
      }
    })
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.role.isCashier) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("操作账号")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "operaValue"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small",
      "disabled": _vm.form.selectShopUid === '' && !_vm.role.single
    },
    on: {
      "change": _vm.operaChange
    },
    model: {
      value: (_vm.form.operaValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "operaValue", $$v)
      },
      expression: "form.operaValue"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "门店主账户",
      "value": "vl"
    }
  }), _vm._v(" "), _vm._l((_vm.operaList), function(label, value) {
    return _c('el-option', {
      key: value,
      attrs: {
        "label": label,
        "value": value
      }
    })
  })], 2)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group down-btn"
  }, [_c('div', {
    staticClass: "panel-select-down-btn",
    on: {
      "click": function($event) {
        return _vm.changePullStatus()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.pullflag ? '收起' : '展开'))]), _vm._v(" "), _c('i', {
    staticClass: "icon-right_arrow",
    class: {
      'icon-down_arrow__rotate': _vm.pullflag
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collpase"
    }
  }, [(_vm.pullflag) ? _c('div', {
    staticClass: "collpase"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("交易方式")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkAll1"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleCheckAllChange1
    },
    model: {
      value: (_vm.form.checkAll1),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkAll1", $$v)
      },
      expression: "form.checkAll1"
    }
  }, [_vm._v("不限")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "type"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedCitiesChange1
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("交易类型")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkAll2"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleCheckAllChange2
    },
    model: {
      value: (_vm.form.checkAll2),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkAll2", $$v)
      },
      expression: "form.checkAll2"
    }
  }, [_vm._v("不限")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "other"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedCitiesChange2
    },
    model: {
      value: (_vm.form.other),
      callback: function($$v) {
        _vm.$set(_vm.form, "other", $$v)
      },
      expression: "form.other"
    }
  }, _vm._l((_vm.otherList), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select-group-btn",
    staticStyle: {
      "padding-left": "70px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group-btn"
  }, [_c('div', {
    staticClass: "panel-header-btn",
    on: {
      "click": _vm.search
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("查询")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn"
  }, [_c('a', {
    staticStyle: {
      "color": "#FE9B20",
      "display": "block",
      "width": "100%"
    },
    attrs: {
      "href": _vm.detailHref,
      "download": ""
    }
  }, [_vm._v("导出")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.transData.data,
      "row-class-name": "el-table__row_fix"
    },
    on: {
      "row-click": _vm.handleRowHandle
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sysdtm",
      "min-width": "100px",
      "label": "交易时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.sysdtm))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "syssn",
      "min-width": "130",
      "label": "流水号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "130",
      "label": "通道流水号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.chnlsn || '无'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "130",
      "label": "商户订单号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.out_trade_no || '无'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "门店分组"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.fenzu_name))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "门店"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.username))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作账号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.opuser))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.total_amt)) + _vm._s(_vm.role.currency))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.txamt)) + _vm._s(_vm.role.currency))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sysdtm",
      "label": "交易方式"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.busicd_info))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trantype",
      "label": "交易类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status_str",
      "label": "订单状态",
      "min-width": "60px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手续费",
      "min-width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.settlefee)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "结算金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.settle_amt)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goods_name || '-'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品信息",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goods_info || '-'))]
      }
    }])
  }), _vm._v(" "), (_vm.role.single && _vm.role.show_refund) ? _c('el-table-column', {
    attrs: {
      "min-width": "100",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-button__fix",
          attrs: {
            "type": "text",
            "size": "small",
            "disabled": !scope.row.allow_refund_amt
          },
          on: {
            "click": function($event) {
              return _vm.confirm(scope.row)
            }
          }
        }, [_vm._v("退款")])]
      }
    }], null, false, 60451996)
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.transData.num >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.transData.num,
      "current-page": _vm.currentPage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _c('div', {
    staticClass: "table_placeholder"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showDetail,
      "custom-class": "dialog_detail",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showDetail = $event
      }
    }
  }, [_c('div', {
    staticClass: "detail_title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', [_vm._v("订单详情")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.sysdtm))])]), _vm._v(" "), _c('div', {
    staticClass: "detail_body"
  }, [_c('div', {
    staticStyle: {
      "padding": "0 20px 10px"
    }
  }, [_c('table', {
    staticClass: "table1"
  }, [_c('tr', {
    staticClass: "table_tr"
  }, [_c('td', {
    staticClass: "table_td table_td1"
  }, [_c('span', [_vm._v(_vm._s(_vm.detailInfo.trantype == '退款' ? '退款流水号' : '订单流水号'))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.syssn))])]), _vm._v(" "), _c('td', {
    staticClass: "table_td table_td2"
  }, [_c('span', [_vm._v("交易类型")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.trantype))])])]), _vm._v(" "), (_vm.detailInfo.trantype == '退款') ? _c('tbody', {
    staticClass: "trantype"
  }, [_c('tr', {
    staticClass: "table_tr"
  }, [_c('td', {
    staticClass: "table_td table_td1"
  }, [_c('span', [_vm._v("原订单流水号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.origssn))])]), _vm._v(" "), _c('td', {
    staticClass: "table_td table_td2"
  }, [_c('span', [_vm._v("交易方式")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.busicd_info))])])]), _vm._v(" "), _c('tr', {
    staticClass: "table_tr"
  }, [_c('td', {
    staticClass: "table_td table_td1"
  }, [_c('span', [_vm._v("通道流水号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.chnlsn || '无'))])]), _vm._v(" "), _c('td', {
    staticClass: "table_td table_td2"
  }, [_c('span', [_vm._v("订单状态")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.status_str))])])]), _vm._v(" "), _c('tr', {
    staticClass: "table_tr"
  }, [_c('td', {
    staticClass: "table_td table_td1"
  }, [_c('span', [_vm._v("商户订单号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.out_trade_no || '无'))])])])]) : _c('tbody', {
    staticClass: "trantype"
  }, [_c('tr', {
    staticClass: "table_tr"
  }, [_c('td', {
    staticClass: "table_td table_td1"
  }, [_c('span', [_vm._v("通道流水号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.chnlsn || '无'))])]), _vm._v(" "), _c('td', {
    staticClass: "table_td table_td2"
  }, [_c('span', [_vm._v("订单状态")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.status_str))])])]), _vm._v(" "), _c('tr', {
    staticClass: "table_tr"
  }, [_c('td', {
    staticClass: "table_td table_td1"
  }, [_c('span', [_vm._v("商户订单号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.out_trade_no || '无'))])]), _vm._v(" "), _c('td', {
    staticClass: "table_td table_td2"
  }, [_c('span', [_vm._v("交易方式")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.busicd_info))])])])]), _vm._v(" "), _c('tr', {
    staticClass: "table_tr"
  }, [_c('td', {
    staticClass: "table_td table_td1"
  }, [_c('span', [_vm._v("门店分组")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.fenzu_name))])]), _vm._v(" "), _c('td', {
    staticClass: "table_td table_td2"
  }, [_c('span', [_vm._v("订单金额")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.detailInfo.total_amt)))])])]), _vm._v(" "), _c('tr', {
    staticClass: "table_tr"
  }, [_c('td', {
    staticClass: "table_td table_td1"
  }, [_c('span', [_vm._v("省份")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.province))])]), _vm._v(" "), _c('td', {
    staticClass: "table_td table_td2"
  }, [_c('span', [_vm._v("交易金额")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.detailInfo.txamt)))])])]), _vm._v(" "), _c('tr', {
    staticClass: "table_tr"
  }, [_c('td', {
    staticClass: "table_td table_td1"
  }, [_c('span', [_vm._v("地市")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.city))])]), _vm._v(" "), _c('td', {
    staticClass: "table_td table_td2"
  }, [_c('span', [_vm._v("手续费")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.detailInfo.settlefee)))])])]), _vm._v(" "), _c('tr', {
    staticClass: "table_tr"
  }, [_c('td', {
    staticClass: "table_td table_td1"
  }, [_c('span', [_vm._v("门店名称")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.username))])]), _vm._v(" "), _c('td', {
    staticClass: "table_td table_td2"
  }, [_c('span', [_vm._v("结算金额")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.detailInfo.settle_amt)))])])]), _vm._v(" "), _c('tr', {
    staticClass: "table_tr"
  }, [_c('td', {
    staticClass: "table_td table_td1"
  }, [_c('span', [_vm._v("操作账号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.detailInfo.opuser))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail_footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.showDetail = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "确认退款",
      "visible": _vm.showConfirm,
      "custom-class": "mydialog",
      "top": "20%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showConfirm = $event
      },
      "close": function($event) {
        return _vm.handleClose('formpwd')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("操作一旦确认将无法撤回，是否确认？")]), _vm._v(" "), _c('el-form', {
    ref: "formpwd",
    attrs: {
      "model": _vm.formpwd,
      "rules": _vm.pwdrules,
      "label-width": "80px",
      "autocomplete": "off"
    }
  }, [_c('el-form-item', {
    staticClass: "amount",
    attrs: {
      "prop": "amount",
      "label": "退款金额"
    }
  }, [_c('span', [_vm._v("￥")]), _vm._v(" "), _c('el-input', {
    staticClass: "showAmount",
    attrs: {
      "name": "amount",
      "placeholder": '最大可退款金额' + _vm.refundAmount,
      "type": "number"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.formpwd.amount),
      callback: function($$v) {
        _vm.$set(_vm.formpwd, "amount", $$v)
      },
      expression: "formpwd.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd",
      "label": "密码"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入登录密码",
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.formpwd.pwd),
      callback: function($$v) {
        _vm.$set(_vm.formpwd, "pwd", $$v)
      },
      expression: "formpwd.pwd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.checkPwd
    }
  }, [(_vm.iconLoading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("确 定")])])])], 1), _vm._v(" "), _c('el-dialog', {
    class: [_vm.refundStates ? 'success' : 'fail'],
    attrs: {
      "title": _vm.refundStates ? '成功' : '失败',
      "visible": _vm.showArefund,
      "custom-class": "mydialog refund",
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showArefund = $event
      }
    }
  }, [(_vm.refundStates) ? _c('div', [_c('el-form', {
    attrs: {
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "退款金额"
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.refundInfo.txamt)))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "交易类型"
    }
  }, [_c('div', [_vm._v("退款")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退款流水号"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.refundInfo.syssn))])])], 1)], 1) : _c('div', {
    staticClass: "refundfail"
  }, [_vm._v("\n      " + _vm._s(_vm.refundInfo.resperr) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "submit",
    on: {
      "click": function($event) {
        _vm.showArefund = false
      }
    }
  }, [_c('span', [_vm._v("确 定")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-df61f7ee"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/transdetail/transdetail.vue
// module id = 857
// module chunks = 0